import React, { memo, useState, useEffect, useCallback } from 'react'
import { Column, ContainerService, DragRowMove, Editors, FieldType, Formatter, Formatters, GridMenuEventWithElementCallbackArgs, GridOption, OnActiveCellChangedEventArgs, OnBeforeEditCellEventArgs, OnCellChangeEventArgs, OnClickEventArgs, OnDragEventArgs, OnEventArgs, OnHeaderClickEventArgs, OnKeyDownEventArgs, OnRenderedEventArgs, OnRowsChangedEventArgs, OnScrollEventArgs, PaginationService, SingleColumnSort, SlickCellSelectionModel, SlickDataView, SlickGrid, SlickRowSelectionModel, SlickgridReact, SlickgridReactInstance, TranslaterService, addWhiteSpaces } from 'slickgrid-react';
import { useDebounceFn, useSetState, useThrottleFn } from 'ahooks'
import { Button, Spin } from 'antd';
import { useRef } from 'react';
import { gridOptions } from './constant';
import { getListById, getTreeData } from './api';
import TaskQueueManager from './core/TaskQueueManager';
import { treeFormatter } from '@/utils/slickgrid';
import styles from './index.module.less';

const Index = (props: any) => {
    const reactGridRef = useRef<SlickgridReactInstance | null>(null)
    const batchUpdateTimeout = useRef<number | NodeJS.Timeout | null>(null);

    type PageDataType = {
        taskMap: Record<string, any>;
        taskManager: TaskQueueManager<any>;
        loadItemIds: Set<any> // 需要api请求的节点
        batchUpdateBuffer: Map<string, any>; // New: Buffer for batch updates
    }
    const pageRefData = useRef<PageDataType>({
        taskMap: {} as any,
        taskManager: null,
        loadItemIds: new Set(),
        batchUpdateBuffer: new Map()
    })

    if (pageRefData.current.taskManager === null) {
        pageRefData.current.taskManager = new TaskQueueManager(6);
    }
    if (pageRefData.current.loadItemIds === null) {
        pageRefData.current.loadItemIds = new Set();
    }
    if (pageRefData.current.batchUpdateBuffer === null) {
        pageRefData.current.batchUpdateBuffer = new Map();
    }

    // 获取任务
    const getTaskById = (itemId) => {
        return pageRefData.current.taskMap[itemId]
    }

    // 设置任务
    const setTask = item => {
        pageRefData.current.taskMap[item.id] = item;
    }

    // 获取 buffer
    const getBuffer = () => pageRefData.current.batchUpdateBuffer
    const initBuffer = (buffer: any) => {
        pageRefData.current.batchUpdateBuffer = buffer
    }
    const setBuffer = (id, buffer) => {
        pageRefData.current.batchUpdateBuffer.set(id, buffer);
    }


    const [state, setState] = useSetState({
        tableList: [] as any[],
        spinning: false,
    })
    const getTableData = async () => {
        const mockData = await getTreeData()
        setState({ tableList: mockData as any[] })
    }

    const handleGetTableData = () => {
        // const data = reactGridRef.current?.dataView.getItems()
        const data = reactGridRef.current?.dataView.getItems()
        console.log('data', data)
    }

    const handleRefresh = () => {
        initBuffer(new Map())
        pageRefData.current.taskMap = new Map()
        pageRefData.current.loadItemIds = new Set()
        getTableData().then(res => {
            // setTimeout(() => {
            //     requestAnimationFrame(() => {
            //         updateViewPortTable();
            //     });
            // }, 0);
        })
    }

    // 批量更新处理函数。批量更新缓冲区
    const processBatchUpdateCell = useCallback(() => {
        if (!reactGridRef.current?.slickGrid) return;
        const dataView = reactGridRef.current.slickGrid.getData();
        const buffer = getBuffer()
        if (buffer.size > 0) {
            console.time('batchUpdate');
            // 暂停重渲染
            dataView.beginUpdate();
            // 处理所有缓冲的更新
            buffer.forEach((newItem, id) => {
                dataView.updateItem(id, newItem);
            });
            // 恢复重渲染
            dataView.endUpdate();
            buffer.clear();
            console.timeEnd('batchUpdate');
        }
    }, []);


    // 缓冲区更新
    const bufferUpdate = useCallback((id: string, newItem: any) => {
        setBuffer(id, newItem)

        if (!batchUpdateTimeout.current) {
            batchUpdateTimeout.current = requestAnimationFrame(() => {
                processBatchUpdateCell();
                batchUpdateTimeout.current = null;
            });
        }

        // Clear existing timeout
        // if (batchUpdateTimeout.current) {
        //     clearTimeout(batchUpdateTimeout.current);
        // }

        // // Schedule new batch update
        // batchUpdateTimeout.current = setTimeout(() => {
        //     processBatchUpdateCell();
        // }, 16); // Roughly one frame at 60fps
    }, [processBatchUpdateCell]);


    // Modified loadExtraInfo function
    const loadExtraInfo = async (item: any) => {
        if (pageRefData.current.loadItemIds.has(item.id)) return;
        if (pageRefData.current.taskMap[item.id]) return;
        console.log("loadExtraInfo", item)
        const dataView = reactGridRef.current?.slickGrid.getData();
        if (!dataView) return;
        // pageRefData.current.taskMap[item.id] = item;
        setTask(item)
        try {
            await pageRefData.current.taskManager.addTask(
                item.id,
                async () => {
                    const result = await getListById({ id: item.id, number: item.ids.length });
                    pageRefData.current.loadItemIds.add(item.id);
                    // Batch process updates
                    result.forEach(element => {
                        if (element.pid === item.id) {
                            const newItem = { ...element };
                            bufferUpdate(element.id, newItem);
                        }
                    });

                    return result;
                }
            );
        } catch (error) {
            console.error('Error loading extra info:', error);
        }
    };

    // const { run: updateViewPortTable } = useDebounceFn(
    //     () => {
    //         requestAnimationFrame(() => {
    //             console.log("updateViewPortTable", reactGridRef.current?.slickGrid.getViewport())
    //             const viewPort = reactGridRef.current?.slickGrid.getViewport() || { top: 0, bottom: 0 };
    //             for (let i = viewPort.top; i <= viewPort.bottom; i++) {
    //                 const item = reactGridRef.current?.slickGrid.getDataItem(i);
    //                 console.log("item2", item.name)
    //                 if (item) {
    //                     // 当前展开，且没有加载过的，需要重新加载
    //                     const isNeedLoad = item && !item.__collapsed && item.__hasChildren && !item.hasLoaded && !getTaskById(item.id);
    //                     // console.log("item2", item, isNeedLoad)
    //                     if (isNeedLoad) {
    //                         console.log("loadExtraInfo", item)
    //                         loadExtraInfo(item);
    //                     }
    //                 }
    //             }
    //         })
    //     },
    //     {
    //         wait: 200,
    //         leading: false,  // 是否在延迟开始前调用函数
    //         trailing: true  // 是否在延迟开始后调用函数
    //     }
    // );


    const { run: updateViewPortTable } = useThrottleFn(
        () => {
            requestAnimationFrame(() => {
                console.log("updateViewPortTable", reactGridRef.current?.slickGrid.getViewport())
                const viewPort = reactGridRef.current?.slickGrid.getViewport() || { top: 0, bottom: 0 };
                for (let i = viewPort.top; i <= viewPort.bottom; i++) {
                    const item = reactGridRef.current?.slickGrid.getDataItem(i);
                    console.log("item2", item.name)
                    if (item) {
                        // 当前展开，且没有加载过的，需要重新加载
                        const isNeedLoad = item && !item.__collapsed && item.__hasChildren && !item.hasLoaded && !getTaskById(item.id);
                        // console.log("item2", item, isNeedLoad)
                        if (isNeedLoad) {
                            console.log("loadExtraInfo", item)
                            loadExtraInfo(item);
                        }
                    }
                }
            })
        },
        {
            wait: 50,
            leading: true,  // 是否在延迟开始前调用函数
            trailing: true  // 是否在延迟开始后调用函数
        }
    );

    // Optimized scroll handler
    const handleScroll = useCallback((e: CustomEvent<{ eventData: any; args: OnScrollEventArgs; }>) => {
        requestAnimationFrame(() => {
            updateViewPortTable();
        });
        console.log('handleScroll')
    }, [updateViewPortTable]);

    const handleReactGrid1Ready = (e: CustomEvent<any>) => {
        const reactGrid: SlickgridReactInstance = e.detail;
        reactGridRef.current = reactGrid
        console.log("reactGridCreate")
        let isUpdated = false
        const dataView = reactGrid.dataView;

        // 点击折叠的时候会触发
        dataView.onRowCountChanged.subscribe((e, args) => {
            const { current, itemCount, previous } = args
            // console.log("onRowCountChanged", e, args)
            console.log("onRowCountChanged", args)
            // if (current > 0 && !isUpdated) {
            //     updateViewPortTable()
            //     isUpdated = true
            // }
            updateViewPortTable()
        });
        // reactGrid.
        // 在数据加载完成时触发
        // reactGrid.dataView.onDataviewCreated.subscribe(() => {
        //     // dataview 创建完成
        // });
    }
    const handleTableClick = (e: CustomEvent<{ eventData: any; args: OnClickEventArgs; }>) => {
        const { eventData, args } = e.detail
        const { row, cell, grid } = args;
        const itemData = grid.getDataItem(row)
        // console.log("itemData", itemData)
        const target = eventData.target as HTMLElement;
        // 判断是否点击了展开/折叠图标
        if (target.classList.contains('slick-group-toggle')) {
            // 展开
            if (target.classList.contains('collapsed')) {
                loadExtraInfo(itemData);
            }
        }
        console.log("handleTableClick", eventData.target)
    }

    const handleViewChange = (e: CustomEvent<{ eventData: any; args: { grid: SlickGrid; }; }>) => {
        // console.log("handleViewChange", e)
    }

    const handleRender = (e: CustomEvent<{ eventData: any; args: OnRenderedEventArgs; }>) => {
        // console.log("handleRender", e)
        // isDatasetLoaded
        // const args = e.detail.args
        // const { grid } = args
        // console.log(grid.)
    }

    const columns: Column[] = [
        {
            id: 'id',
            name: 'id',
            field: 'id',
            minWidth: 100,
            cssClass: 'slickgrid_column_number slickgrid-checkbox-center-cls',
            behavior: "select",
            sortable: false,
        },
        {
            id: 'name',
            field: 'name',
            name: '名称',
            minWidth: 460,
            cssClass: 'slickgrid-edit slickgrid-num-left-cls',
            sortable: false,
            formatter: treeFormatter
        },
        {
            id: 'price',
            field: 'price',
            name: '价格',
            minWidth: 360,
            cssClass: 'slickgrid-edit',
            sortable: false,
        },
        {
            id: 'quantity',
            field: 'quantity',
            name: '数量',
            minWidth: 360,
            cssClass: 'slickgrid-edit',
            sortable: true,
        },
    ]

    const init = async () => {
        getTableData()
    }

    useEffect(() => {
        init()

        // 组件卸载时的清理函数
        return () => {
            // 1. 清除批量更新定时器
            if (batchUpdateTimeout.current) {
                clearTimeout(batchUpdateTimeout.current);
                batchUpdateTimeout.current = null;
            }

            // 2. 终止所有进行中的任务
            pageRefData.current.taskManager.clear();

            // 3. 移除数据视图的事件监听
            const dataView = reactGridRef.current?.dataView;
            if (dataView) {
                dataView.onRowCountChanged.unsubscribe(); // 取消订阅事件
            }

            // 4. 清空缓存数据
            pageRefData.current.batchUpdateBuffer.clear();
            pageRefData.current.loadItemIds.clear();
            pageRefData.current.taskMap = {};
        };
    }, [])


    console.log("state.tableList", state.tableList)

    return (<div className={styles['container']}>
        <div className={styles['tableHeader']}>
            <div className={styles['opWrap']}>
                {/* <Button onClick={handleAdd}>添加</Button> */}
                <Button onClick={handleGetTableData}>获取表格数据</Button>
                <Button onClick={handleRefresh}>刷新表格</Button>
            </div>
        </div>
        <div className={styles['tableBody']} id='indicator_zjzb_table_container111'>
            <Spin style={{ zIndex: state.spinning ? 99999999999 : 0 }} spinning={state.spinning} className={styles.tableSpin}></Spin>
            <SlickgridReact
                gridId='grid1'
                columnDefinitions={columns}
                onViewportChanged={handleViewChange}
                onClick={handleTableClick}
                onRendered={handleRender}
                gridOptions={gridOptions}
                datasetHierarchical={state.tableList}
                onScroll={handleScroll}
                onReactGridCreated={handleReactGrid1Ready}
            // onTreeFullToggleEnd={handleToggleTreeCollapsed}
            />
        </div>
    </div>)
}

export default Index